// src/admin/adminMockData.js
export const mockPros = [
  {
    id: "PRO-001",
    name: "Grace Wanjiku",
    phone: "+254 712 345 678",
    email: "grace@jirani.ke",
    category: "Cleaning",
    earnings: 38500,
    rating: 4.9,
    status: "active",
    jobsCompleted: 214,
    lastActive: "2026-04-05T10:00:00Z",
    location: "Westlands, Nairobi",
    joined: "2024-01-12",
    verification: "verified",
    featured: true,
    bio: "Experienced cleaner with 5+ years. Deep cleaning specialist.",
    lastPayout: 22000,
    pendingPayout: 16500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "Anne K.", rating: 5, text: "Grace left my house spotless." },
      { user: "David M.", rating: 5, text: "Very thorough and professional." }
    ],
    jobHistory: [
      { name: "Deep Clean – Kilimani", status: "completed", amount: 3500 },
      { name: "Office Clean – CBD", status: "completed", amount: 5000 },
      { name: "Post-Construction – Karen", status: "completed", amount: 8000 },
      { name: "Weekly Clean – Lavington", status: "completed", amount: 2500 },
      { name: "Move-Out Clean – Westlands", status: "completed", amount: 4000 },
    ]
  },
  {
    id: "PRO-002",
    name: "Brian Otieno",
    phone: "+254 723 456 789",
    email: "brian@jirani.ke",
    category: "Plumbing",
    earnings: 42500,
    rating: 4.8,
    status: "active",
    jobsCompleted: 189,
    lastActive: "2026-04-04T14:30:00Z",
    location: "Kilimani, Nairobi",
    joined: "2024-02-20",
    verification: "verified",
    featured: false,
    bio: "Licensed plumber specializing in residential installations.",
    lastPayout: 28000,
    pendingPayout: 14500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "Susan M.", rating: 5, text: "Fast and reliable." },
      { user: "Peter O.", rating: 4, text: "Fixed our burst pipe quickly." }
    ],
    jobHistory: [
      { name: "Pipe Repair – Kilimani", status: "completed", amount: 3500 },
      { name: "Installation – Westlands", status: "completed", amount: 7500 },
      { name: "Emergency Fix – CBD", status: "disputed", amount: 4500 },
    ]
  },
  {
    id: "PRO-003",
    name: "Amina Hassan",
    phone: "+254 734 567 890",
    email: "amina@jirani.ke",
    category: "Tutoring",
    earnings: 18500,
    rating: 4.7,
    status: "pending",
    jobsCompleted: 97,
    lastActive: "2026-04-03T09:15:00Z",
    location: "Lavington, Nairobi",
    joined: "2024-03-15",
    verification: "pending",
    featured: false,
    bio: "Cambridge-trained educator offering math and science tutoring.",
    lastPayout: 12000,
    pendingPayout: 6500,
    idVerified: true,
    docsSubmitted: false,
    approvalStatus: "pending",
    reviews: [
      { user: "Alice W.", rating: 5, text: "My son improved so much!" }
    ],
    jobHistory: [
      { name: "Math Tutoring – Lavington", status: "completed", amount: 2500 },
      { name: "Science Class – Karen", status: "completed", amount: 3000 },
    ]
  },
  {
    id: "PRO-004",
    name: "Samuel Kamau",
    phone: "+254 745 678 901",
    email: "samuel@jirani.ke",
    category: "Electrical",
    earnings: 52000,
    rating: 4.9,
    status: "active",
    jobsCompleted: 156,
    lastActive: "2026-04-05T08:00:00Z",
    location: "Karen, Nairobi",
    joined: "2024-01-05",
    verification: "verified",
    featured: true,
    bio: "ERC-licensed electrician handling wiring and installations.",
    lastPayout: 35000,
    pendingPayout: 17000,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "David L.", rating: 5, text: "Professional and safe." }
    ],
    jobHistory: [
      { name: "House Rewiring – Karen", status: "completed", amount: 15000 },
      { name: "Lighting Install – Runda", status: "completed", amount: 8000 },
    ]
  },
  {
    id: "PRO-005",
    name: "Fatuma Abdalla",
    phone: "+254 756 789 012",
    email: "fatuma@jirani.ke",
    category: "Catering",
    earnings: 9500,
    rating: 4.5,
    status: "suspended",
    jobsCompleted: 63,
    lastActive: "2026-03-28T16:00:00Z",
    location: "Parklands, Nairobi",
    joined: "2024-04-10",
    verification: "rejected",
    featured: false,
    bio: "Chef specializing in Swahili cuisine.",
    lastPayout: 5000,
    pendingPayout: 4500,
    idVerified: false,
    docsSubmitted: false,
    approvalStatus: "rejected",
    reviews: [
      { user: "Zara A.", rating: 5, text: "Food was amazing!" }
    ],
    jobHistory: [
      { name: "Event Catering – Parklands", status: "disputed", amount: 9500 },
    ]
  },
  {
    id: "PRO-006",
    name: "Kevin Mwangi",
    phone: "+254 767 890 123",
    email: "kevin@jirani.ke",
    category: "Gardening",
    earnings: 12500,
    rating: 4.3,
    status: "pending",
    jobsCompleted: 42,
    lastActive: "2026-04-02T11:00:00Z",
    location: "Runda, Nairobi",
    joined: "2024-05-20",
    verification: "pending",
    featured: false,
    bio: "Landscape gardener with expertise in indigenous plants.",
    lastPayout: 8000,
    pendingPayout: 4500,
    idVerified: false,
    docsSubmitted: true,
    approvalStatus: "pending",
    reviews: [],
    jobHistory: [
      { name: "Garden Design – Runda", status: "completed", amount: 7500 },
      { name: "Lawn Maintenance – Gigiri", status: "completed", amount: 5000 },
    ]
  },
  {
    id: "PRO-007",
    name: "Diana Chebet",
    phone: "+254 778 901 234",
    email: "diana@jirani.ke",
    category: "Babysitting",
    earnings: 22500,
    rating: 4.9,
    status: "active",
    jobsCompleted: 78,
    lastActive: "2026-04-05T12:00:00Z",
    location: "Gigiri, Nairobi",
    joined: "2024-03-01",
    verification: "verified",
    featured: true,
    bio: "Certified childcare professional with first aid training.",
    lastPayout: 15000,
    pendingPayout: 7500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "Rachel T.", rating: 5, text: "Best babysitter we've had!" }
    ],
    jobHistory: [
      { name: "Weekend Care – Gigiri", status: "completed", amount: 4000 },
      { name: "Evening Sitting – Runda", status: "completed", amount: 3500 },
    ]
  },
  {
    id: "PRO-008",
    name: "Moses Kiprop",
    phone: "+254 789 012 345",
    email: "moses@jirani.ke",
    category: "Moving",
    earnings: 31500,
    rating: 4.6,
    status: "active",
    jobsCompleted: 121,
    lastActive: "2026-04-04T09:00:00Z",
    location: "Syokimau, Nairobi",
    joined: "2024-02-15",
    verification: "verified",
    featured: false,
    bio: "Professional mover with truck and team.",
    lastPayout: 20000,
    pendingPayout: 11500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "John M.", rating: 4, text: "Efficient and careful with items." }
    ],
    jobHistory: [
      { name: "Office Move – CBD", status: "completed", amount: 12000 },
      { name: "House Relocation – Syokimau", status: "completed", amount: 19500 },
    ]
  },
  {
    id: "PRO-009",
    name: "Lucy Njeri",
    phone: "+254 701 234 567",
    email: "lucy@jirani.ke",
    category: "Cleaning",
    earnings: 28500,
    rating: 4.7,
    status: "active",
    jobsCompleted: 167,
    lastActive: "2026-04-04T15:00:00Z",
    location: "Eastlands, Nairobi",
    joined: "2024-01-20",
    verification: "verified",
    featured: false,
    bio: "Detailed cleaning specialist for homes and offices.",
    lastPayout: 18000,
    pendingPayout: 10500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "Mary K.", rating: 5, text: "Very thorough cleaner." },
      { user: "James N.", rating: 4, text: "Good value for money." }
    ],
    jobHistory: [
      { name: "Deep Clean – Eastlands", status: "completed", amount: 4500 },
      { name: "Office Clean – Industrial Area", status: "completed", amount: 8000 },
    ]
  },
  {
    id: "PRO-010",
    name: "Peter Muthama",
    phone: "+254 712 890 123",
    email: "peter@jirani.ke",
    category: "Electrical",
    earnings: 18500,
    rating: 4.4,
    status: "suspended",
    jobsCompleted: 89,
    lastActive: "2026-03-25T10:00:00Z",
    location: "Umoja, Nairobi",
    joined: "2024-04-05",
    verification: "rejected",
    featured: false,
    bio: "Electrician specializing in home repairs.",
    lastPayout: 10000,
    pendingPayout: 8500,
    idVerified: false,
    docsSubmitted: false,
    approvalStatus: "rejected",
    reviews: [],
    jobHistory: [
      { name: "Socket Repair – Umoja", status: "disputed", amount: 3500 },
      { name: "Lighting Fix – Donholm", status: "disputed", amount: 2500 },
    ]
  },
  {
    id: "PRO-011",
    name: "Sarah Kimani",
    phone: "+254 723 901 234",
    email: "sarah@jirani.ke",
    category: "Tutoring",
    earnings: 15500,
    rating: 4.8,
    status: "pending",
    jobsCompleted: 54,
    lastActive: "2026-04-03T13:00:00Z",
    location: "Buruburu, Nairobi",
    joined: "2024-05-10",
    verification: "pending",
    featured: false,
    bio: "English and literature tutor for high school students.",
    lastPayout: 10000,
    pendingPayout: 5500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "pending",
    reviews: [
      { user: "Michael O.", rating: 5, text: "Excellent teaching methods." }
    ],
    jobHistory: [
      { name: "English Tutoring – Buruburu", status: "completed", amount: 3000 },
    ]
  },
  {
    id: "PRO-012",
    name: "James Omondi",
    phone: "+254 734 012 345",
    email: "james@jirani.ke",
    category: "Plumbing",
    earnings: 34500,
    rating: 4.7,
    status: "active",
    jobsCompleted: 145,
    lastActive: "2026-04-05T07:30:00Z",
    location: "Langata, Nairobi",
    joined: "2024-01-25",
    verification: "verified",
    featured: false,
    bio: "Plumbing specialist with 8 years experience.",
    lastPayout: 22000,
    pendingPayout: 12500,
    idVerified: true,
    docsSubmitted: true,
    approvalStatus: "approved",
    reviews: [
      { user: "Ann W.", rating: 5, text: "Very responsive and professional." }
    ],
    jobHistory: [
      { name: "Bathroom Install – Langata", status: "completed", amount: 12000 },
      { name: "Leak Repair – Karen", status: "completed", amount: 4500 },
    ]
  }
];

export const mockCustomers = [
  { id: "CUST-001", name: "Amina Wanjiru", phone: "+254712345678", email: "amina@email.com", location: "Westlands, Nairobi", joined: "2023-03-12T00:00:00Z", totalJobs: 8, totalSpend: 14500, status: "active" },
  { id: "CUST-002", name: "Brian Otieno", phone: "+254723456789", email: "brian@email.com", location: "Kilimani, Nairobi", joined: "2023-06-20T00:00:00Z", totalJobs: 3, totalSpend: 5200, status: "active" },
  { id: "CUST-003", name: "Cynthia Muthoni", phone: "+254734567890", email: "cynthia@email.com", location: "Lavington, Nairobi", joined: "2023-09-05T00:00:00Z", totalJobs: 12, totalSpend: 28000, status: "active" },
  { id: "CUST-004", name: "David Kamau", phone: "+254745678901", email: "david@email.com", location: "Kasarani, Nairobi", joined: "2024-01-14T00:00:00Z", totalJobs: 1, totalSpend: 1800, status: "inactive" },
  { id: "CUST-005", name: "Esther Njeri", phone: "+254756789012", email: "esther@email.com", location: "Parklands, Nairobi", joined: "2024-02-28T00:00:00Z", totalJobs: 5, totalSpend: 9300, status: "active" },
  { id: "CUST-006", name: "Felix Ochieng", phone: "+254767890123", email: "felix@email.com", location: "South B, Nairobi", joined: "2023-11-03T00:00:00Z", totalJobs: 7, totalSpend: 11600, status: "active" },
  { id: "CUST-007", name: "Grace Akinyi", phone: "+254778901234", email: "grace@email.com", location: "Embakasi, Nairobi", joined: "2024-03-17T00:00:00Z", totalJobs: 2, totalSpend: 3400, status: "inactive" },
  { id: "CUST-008", name: "Hassan Mwangi", phone: "+254789012345", email: "hassan@email.com", location: "Karen, Nairobi", joined: "2023-07-22T00:00:00Z", totalJobs: 15, totalSpend: 31000, status: "active" },
];

export const mockJobs = [
  { id: "JOB-001", title: "Deep House Cleaning", customer: "Amina Wanjiru", pro: "James Kariuki", category: "Cleaning", amount: 3500, status: "completed", date: "2024-04-10T09:00:00Z", location: "Westlands" },
  { id: "JOB-002", title: "Pipe Leak Repair", customer: "Brian Otieno", pro: "Peter Omondi", category: "Plumbing", amount: 2200, status: "completed", date: "2024-04-08T11:00:00Z", location: "Kilimani" },
  { id: "JOB-003", title: "Electrical Wiring Check", customer: "Cynthia Muthoni", pro: "Samuel Njoroge", category: "Electrical", amount: 4800, status: "in_progress", date: "2024-04-12T08:00:00Z", location: "Lavington" },
  { id: "JOB-004", title: "Garden Landscaping", customer: "Hassan Mwangi", pro: "John Waweru", category: "Gardening", amount: 6500, status: "completed", date: "2024-03-30T07:00:00Z", location: "Karen" },
  { id: "JOB-005", title: "AC Installation", customer: "Esther Njeri", pro: "Michael Gitau", category: "Electrical", amount: 12000, status: "disputed", date: "2024-04-05T10:00:00Z", location: "Parklands" },
  { id: "JOB-006", title: "Painting - 2 Rooms", customer: "Felix Ochieng", pro: "Charles Maina", category: "Painting", amount: 8500, status: "completed", date: "2024-03-25T08:00:00Z", location: "South B" },
  { id: "JOB-007", title: "Sofa Deep Clean", customer: "Grace Akinyi", pro: "James Kariuki", category: "Cleaning", amount: 1800, status: "cancelled", date: "2024-04-01T14:00:00Z", location: "Embakasi" },
  { id: "JOB-008", title: "CCTV Installation", customer: "David Kamau", pro: "Robert Kimani", category: "Security", amount: 15000, status: "completed", date: "2024-03-18T09:00:00Z", location: "Kasarani" },
  { id: "JOB-009", title: "Kitchen Sink Fix", customer: "Amina Wanjiru", pro: "Peter Omondi", category: "Plumbing", amount: 1500, status: "completed", date: "2024-04-11T13:00:00Z", location: "Westlands" },
  { id: "JOB-010", title: "Move & Assemble Furniture", customer: "Cynthia Muthoni", pro: "John Waweru", category: "Moving", amount: 5000, status: "in_progress", date: "2024-04-13T07:00:00Z", location: "Lavington" },
];

export const mockPayments = [
  { id: "PAY-001", pro: "James Kariuki", customer: "Amina Wanjiru", amount: 3500, type: "payout", status: "completed", date: "2024-04-10T18:00:00Z" },
  { id: "PAY-002", pro: "Peter Omondi", customer: "Brian Otieno", amount: 2200, type: "payout", status: "completed", date: "2024-04-08T19:00:00Z" },
  { id: "PAY-003", pro: "Samuel Njoroge", customer: "Cynthia Muthoni", amount: 4800, type: "charge", status: "pending", date: "2024-04-12T08:00:00Z" },
  { id: "PAY-004", pro: "John Waweru", customer: "Hassan Mwangi", amount: 6500, type: "payout", status: "completed", date: "2024-03-30T20:00:00Z" },
  { id: "PAY-005", pro: "Michael Gitau", customer: "Esther Njeri", amount: 12000, type: "charge", status: "failed", date: "2024-04-05T10:00:00Z" },
  { id: "PAY-006", pro: "Charles Maina", customer: "Felix Ochieng", amount: 8500, type: "payout", status: "completed", date: "2024-03-25T21:00:00Z" },
  { id: "PAY-007", pro: "Robert Kimani", customer: "David Kamau", amount: 15000, type: "payout", status: "completed", date: "2024-03-18T20:00:00Z" },
  { id: "PAY-008", pro: "Peter Omondi", customer: "Amina Wanjiru", amount: 1500, type: "payout", status: "completed", date: "2024-04-11T19:00:00Z" },
  { id: "PAY-009", pro: "James Kariuki", customer: "Grace Akinyi", amount: 1800, type: "charge", status: "failed", date: "2024-04-01T14:00:00Z" },
  { id: "PAY-010", pro: "John Waweru", customer: "Cynthia Muthoni", amount: 5000, type: "charge", status: "pending", date: "2024-04-13T07:00:00Z" },
];

export const mockMediaFiles = [
  { id: "MED-001", name: "profile_james.jpg", type: "image", size: "1.2 MB", uploadedBy: "James Kariuki", date: "2024-03-10T10:00:00Z", url: "/media/profile_james.jpg" },
  { id: "MED-002", name: "id_peter.pdf", type: "document", size: "0.8 MB", uploadedBy: "Peter Omondi", date: "2024-03-12T11:00:00Z", url: "/media/id_peter.pdf" },
  { id: "MED-003", name: "work_sample_charles.jpg", type: "image", size: "2.4 MB", uploadedBy: "Charles Maina", date: "2024-03-15T09:00:00Z", url: "/media/work_sample_charles.jpg" },
  { id: "MED-004", name: "certificate_samuel.pdf", type: "document", size: "1.1 MB", uploadedBy: "Samuel Njoroge", date: "2024-03-18T14:00:00Z", url: "/media/certificate_samuel.pdf" },
  { id: "MED-005", name: "intro_video_john.mp4", type: "video", size: "18.5 MB", uploadedBy: "John Waweru", date: "2024-03-20T08:00:00Z", url: "/media/intro_john.mp4" },
  { id: "MED-006", name: "profile_michael.jpg", type: "image", size: "0.9 MB", uploadedBy: "Michael Gitau", date: "2024-03-22T16:00:00Z", url: "/media/profile_michael.jpg" },
  { id: "MED-007", name: "license_robert.pdf", type: "document", size: "1.5 MB", uploadedBy: "Robert Kimani", date: "2024-03-25T13:00:00Z", url: "/media/license_robert.pdf" },
  { id: "MED-008", name: "portfolio_charles.mp4", type: "video", size: "24.0 MB", uploadedBy: "Charles Maina", date: "2024-03-28T10:00:00Z", url: "/media/portfolio_charles.mp4" },
];

export const mockChartData = {
  revenueByMonth: [
    { month: "May", revenue: 82000 }, { month: "Jun", revenue: 95000 },
    { month: "Jul", revenue: 110000 }, { month: "Aug", revenue: 98000 },
    { month: "Sep", revenue: 125000 }, { month: "Oct", revenue: 140000 },
    { month: "Nov", revenue: 133000 }, { month: "Dec", revenue: 187000 },
    { month: "Jan", revenue: 105000 }, { month: "Feb", revenue: 118000 },
    { month: "Mar", revenue: 132000 }, { month: "Apr", revenue: 154000 },
  ],
  jobsByMonth: [
    { month: "May", jobs: 34 }, { month: "Jun", jobs: 41 },
    { month: "Jul", jobs: 55 }, { month: "Aug", jobs: 48 },
    { month: "Sep", jobs: 62 }, { month: "Oct", jobs: 71 },
    { month: "Nov", jobs: 66 }, { month: "Dec", jobs: 89 },
    { month: "Jan", jobs: 52 }, { month: "Feb", jobs: 59 },
    { month: "Mar", jobs: 67 }, { month: "Apr", jobs: 78 },
  ],
};

export const mockActivityFeed = [
  { id: "ACT-001", type: "pro_joined", message: "James Kariuki joined as a Cleaning pro", time: "2024-04-13T07:30:00Z" },
  { id: "ACT-002", type: "job_completed", message: "Peter Omondi completed a Plumbing job in Westlands", time: "2024-04-13T06:15:00Z" },
  { id: "ACT-003", type: "payment_made", message: "KES 6,500 payout sent to John Waweru", time: "2024-04-12T22:00:00Z" },
  { id: "ACT-004", type: "dispute_raised", message: "Dispute raised on AC Installation job in Parklands", time: "2024-04-12T15:45:00Z" },
  { id: "ACT-005", type: "pro_joined", message: "Grace Akinyi joined as a Gardening pro", time: "2024-04-12T09:00:00Z" },
  { id: "ACT-006", type: "job_completed", message: "Charles Maina completed a Painting job in South B", time: "2024-04-11T18:30:00Z" },
  { id: "ACT-007", type: "payment_made", message: "KES 15,000 payout sent to Robert Kimani", time: "2024-04-11T12:00:00Z" },
  { id: "ACT-008", type: "job_completed", message: "Samuel Njoroge completed an Electrical job in Lavington", time: "2024-04-10T16:00:00Z" },
];

export const mockCategories = [
  { id: "CAT-001", name: "Cleaning", icon: "🧹", totalPros: 42, totalJobs: 310, active: true },
  { id: "CAT-002", name: "Plumbing", icon: "🔧", totalPros: 28, totalJobs: 195, active: true },
  { id: "CAT-003", name: "Electrical", icon: "⚡", totalPros: 31, totalJobs: 220, active: true },
  { id: "CAT-004", name: "Painting", icon: "🖌️", totalPros: 19, totalJobs: 140, active: true },
  { id: "CAT-005", name: "Gardening", icon: "🌿", totalPros: 15, totalJobs: 98, active: true },
  { id: "CAT-006", name: "Security", icon: "🔒", totalPros: 12, totalJobs: 74, active: true },
  { id: "CAT-007", name: "Moving", icon: "📦", totalPros: 9, totalJobs: 55, active: false },
  { id: "CAT-008", name: "Carpentry", icon: "🪚", totalPros: 7, totalJobs: 38, active: true },
];